import { render } from "./PolyImage.vue?vue&type=template&id=56e68a4e"
const script = {}
script.render = render

export default script